export default __webpack_public_path__ + "fe2b7386b6f6ddcfe132c6e440f521cb.svg";